import { StringId } from '../localizer/stringId'

export const strings = {
  [StringId.DV_DP_live_badge_text]: 'LIVE',
}
